import {Card} from 'antd';
import React, {useEffect, useState} from 'react';
import {useDispatch} from 'react-redux';

import {Form as FormComponent, EFormMode} from 'components/form';
import {FormModalWrapper} from 'components/form-modal/form-modal-wrapper';
import {Spinner} from 'components/spinner';
import {
    loadMetadata, resetMetadata, selectFormEntityMetadata, setMetadata,
} from 'entities/metadata';
import {loadFormData, resetLoadedData} from 'modules/data';
import {initBlankForm, performActionForForm} from 'modules/data/data-actions';
import {selectFilterEntityData, selectFormEntityData} from 'modules/data/data-selectors';
import {EEntityType} from 'shared/constants/entities';
import {ILookupEntry} from 'shared/types/lookups';
import {ERequestType} from 'shared/types/requests';
import {useAppSelector} from 'store/config/hooks';
import {TModalComponentInterface, selectModalData} from 'store/slices/modals-slice';

import {
    MONITOR_PROGRAM_KEY,
    SettingMappingHeaderCsvField,
} from '../../constants/setting-program.constants';

export const SettingProgramMappingModal = ({
    onClose,
    parameters,
}: TModalComponentInterface) => {
    const dispatch = useDispatch();
    const [isInitForm, setInitForm] = useState<boolean>(false);
    const entityName = useAppSelector(state => selectModalData(state)?.entityName) || '';
    const filter = useAppSelector(selectFilterEntityData(entityName));
    const paramMonitorProgram: ILookupEntry = filter?.data?.paramMonitorProgramId as ILookupEntry;
    const isMonitorParsingCsv = paramMonitorProgram?.attribute1 === MONITOR_PROGRAM_KEY;
    const {url, recordId} = parameters || {};
    const metadata = useAppSelector(selectFormEntityMetadata(entityName));
    const data = useAppSelector(selectFormEntityData(entityName));
    const actionForForm = (
        name: string,
        referenceUrl: string,
        requestType: ERequestType,
        newData: Record<string, any>,
        isJsonRequest?: boolean,
        urlParamKey?: string,
    ) => dispatch(performActionForForm()(
        name,
        referenceUrl,
        requestType,
        {programId: paramMonitorProgram?.id, ...newData},
        isJsonRequest,
        urlParamKey,
    ));

    useEffect(() => {
        if (recordId) {
            dispatch(loadMetadata(entityName, EEntityType.FORM));
            dispatch(loadFormData(entityName, recordId, url));
        } else {
            dispatch(initBlankForm(entityName));
        }
        return () => {
            dispatch(resetLoadedData(entityName, EEntityType.FORM));
            dispatch(resetMetadata({entityName, entityType: EEntityType.FORM, loading: false}));
        };
    }, []);

    useEffect(() => {
        if (metadata && !isInitForm) {
            setInitForm(true);
            if (isMonitorParsingCsv) {
                dispatch(setMetadata({
                    entityName,
                    entityType: EEntityType.FORM,
                    metadata: {
                        ...metadata,
                        fields: [...metadata?.fields?.slice(0, -1), SettingMappingHeaderCsvField],
                    },
                }));
                setInitForm(true);
            }
        }
    }, [metadata, isMonitorParsingCsv]);

    return (
        <FormModalWrapper
            entityName={entityName}
            onClose={onClose}
        >
            {handleClose => (
                isInitForm ? (
                    <FormComponent
                        onClose={handleClose}
                        formData={data}
                        entityName={entityName}
                        mode={recordId ? EFormMode.EDIT : EFormMode.CREATE}
                        meta={metadata}
                        actionForForm={actionForForm}
                    />
                ) : (<Card style={{paddingTop: 20}}> <Spinner /></Card>)
            )}
        </FormModalWrapper>
    );
};
